import { createContext, useContext } from "react";
import useOemData from "../global/hooks/useOemData";

export const ConfigContext = createContext([]);

export const ConfigProvider = ({ children }) => {
  const { oemNo, oemData, loading, error } = useOemData();

  return (
    <ConfigContext.Provider value={{ oemNo, oemData, loading, error }}>
      {children}
    </ConfigContext.Provider>
  );
};

// Custom hook for easy access to the context
export const useConfigData = () => {
  const context = useContext(ConfigContext);

  if (context === undefined) {
    throw new Error("useConfig must be used within an ConfigProvider");
  }

  return context;
};
